"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AlertSizes = exports.AlertSeverity = void 0;

var _react = _interopRequireDefault(require("react"));

var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

var _Typography = _interopRequireDefault(require("../../protons/typography/Typography"));

var _NotificationIcon = _interopRequireDefault(require("../../protons/icons/NotificationIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    alert: {
      padding: 0,
      color: undefined,
      backgroundColor: theme.palette.common.white,
      "& .MuiAlert-icon": {
        margin: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme.palette.common.white
      }
    },
    small: {
      "& .MuiAlert-icon": _defineProperty({
        padding: theme.spacing(2, 1.75)
      }, theme.breakpoints.down("xs"), {
        padding: theme.spacing(1.5, 1.75)
      }),
      "& .MuiAlert-message": _defineProperty({
        padding: theme.spacing(2, 2.5)
      }, theme.breakpoints.down("xs"), {
        padding: theme.spacing(1.5, 2)
      })
    },
    large: {
      display: "flex",
      flexDirection: "column",
      "& .MuiAlert-icon": {
        padding: 6
      },
      "& .MuiAlert-message": _defineProperty({
        padding: theme.spacing(2.5, 3)
      }, theme.breakpoints.down("xs"), {
        padding: theme.spacing(2, 2.5)
      })
    },
    critical: {
      "& .MuiAlert-icon": {
        backgroundColor: theme.palette.error.main
      }
    },
    neutral: {
      "& .MuiAlert-icon": {
        backgroundColor: theme.palette.warning.main
      }
    },
    positive: {
      "& .MuiAlert-icon": {
        backgroundColor: theme.palette.success.main
      }
    }
  };
});
var severityMap = {
  critical: "error",
  neutral: "warning",
  positive: "success"
};
/**
 * **Alerts deliver important messages to users about their tasks or the system.**
 *
 * There are 2 types of notification: Small, large
 *
 * There are 3 colors of notification: Positive, Neutral, Critical
 */

var Alert = function Alert(_ref) {
  var _classNames;

  var text = _ref.text,
      severity = _ref.severity,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["text", "severity", "type"]);

  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Alert.default, _extends({
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.alert, true), _defineProperty(_classNames, styles[type], true), _defineProperty(_classNames, styles[severity], true), _classNames)),
    variant: "outlined",
    severity: severityMap[severity],
    iconMapping: {
      error: /*#__PURE__*/_react.default.createElement(_NotificationIcon.default, {
        icon: "ic_info"
      }),
      success: /*#__PURE__*/_react.default.createElement(_NotificationIcon.default, {
        icon: "ic_tick"
      }),
      warning: /*#__PURE__*/_react.default.createElement(_NotificationIcon.default, {
        icon: "ic_warning"
      })
    }
  }, props), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body",
    align: type === 'large' ? 'center' : 'left',
    text: text
  }));
};

Alert.propTypes = {
  /** The alert type variant */
  type: _propTypes.default.oneOf(['small', 'large']),

  /** The Alert color variant */
  severity: _propTypes.default.oneOf(['critical', 'neutral', 'positive']),

  /** The alert message text */
  text: _propTypes.default.string.isRequired
};
Alert.defaultProps = {
  severity: "critical",
  type: "small"
};
var AlertSeverity = ['critical', 'neutral', 'positive'];
exports.AlertSeverity = AlertSeverity;
var AlertSizes = ['small', 'large'];
exports.AlertSizes = AlertSizes;
var _default = Alert;
exports.default = _default;